import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("if_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("if_token");
      localStorage.removeItem("if_user");
    }
    // 402 = Pro subscription required. Broadcast a global event so any
    // component (e.g. <UpgradeModalListener/>) can intercept and prompt.
    if (err.response?.status === 402) {
      window.dispatchEvent(
        new CustomEvent("bmai:upgrade-required", {
          detail: { message: err.response?.data?.detail || "Pro required" },
        })
      );
    }
    return Promise.reject(err);
  }
);
